import { DestroyRef, inject, Injectable, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';
import { menus as configuredMenus } from '../consts/menu';
import { Menu } from '../models/menu';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);
  readonly isOpen = signal(false);
  readonly selected = signal(this.normalizeUrl(this.router.url));

  constructor() {
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((event) => {
        this.selected.set(this.normalizeUrl(event.urlAfterRedirects));
      });
  }

  //Armazena internamente os itens
  private readonly menuItems = signal<Menu[]>(this.sortMenus(configuredMenus));

  //Expõe o menu como um signal somente para leitura
  readonly items = this.menuItems.asReadonly();

  setSignal(value: boolean): void {
    this.isOpen.set(value);
  }

  setItems(items: Menu[]): void {
    this.menuItems.set(this.sortMenus(items));
  }

  resetItems(): void {
    this.menuItems.set(this.sortMenus(configuredMenus));
  }

  //Ordena itens e submenus sem alterar diretamente a constante original
  private sortMenus(items: Menu[]): Menu[] {
    return items
      .map((item) => ({
        ...item,
        subMenu: item.subMenu ? this.sortMenus(item.subMenu) : undefined,
      }))
      .sort((first, second) => first.displayOrder - second.displayOrder);
  }

  private normalizeUrl(url: string): string {
    const path = url.split('?')[0].split('#')[0];

    return path || '/';
  }

  //Atualiza as areas de operação do menu
  setOperationalAreas(areas: Menu[]): void {
    const updatedMenus = configuredMenus.map((menu) =>
      menu.id === 'operational-areas'
        ? {
            ...menu,
            subMenu: areas,
          }
        : menu,
    );

    this.setItems(updatedMenus);
  }
}
